module.exports = __webpack_public_path__ + "img/send-icon.63d5709b.svg";